<template>
    <div v-if="disabled">

    </div>
    <div v-else>
    <v-menu
        max-width="80%"
        v-model="dateMenu"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                class="datePickerText"
                solo
                flat
                :value="formattedDate"
                readonly
                dense
                :persistent-placeholder="true"
                placeholder="Bitte wählen"
                @click:clear="clearDateValue"
                v-bind="attrs"
                v-on="on">
                <template v-slot:prepend-inner>
                    <v-icon small class="mr-2">fa-calendar-week</v-icon>
                </template>
                <template v-slot:append-outer>
                    <v-icon class="mt-1" @click="dateMenu=!dateMenu">fa-caret-down</v-icon>
                </template>
            </v-text-field>
        </template>
        <v-date-picker
            style="display: flex; width: unset;"
            class="posManagerWeekDatePicker"
            :max="maxDate"
            v-model="date"
            :first-day-of-week="firstDayOfWeek"
            type="date"
            :title-date-format="()=>formattedDate"
           @click="dayChanged"
            @input="dayChanged"
        ></v-date-picker>
    </v-menu>
    </div>
</template>
<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import moment, {Moment} from "moment-mini";

@Component({components: {}})
export default class DayDatePicker extends Vue {

    @Prop({default: false}) disabled!: boolean;
    private date: string = '';
    private formattedDate: string = '';
    private dateMenu: boolean = false;

    // private getDateOfWeek(w:number, y:number) {
    //     const d = (1 + (w - 1) * 7); // 1st of January + 7 days for each week
    //     return new Date(y, 0, d);
    // }

    private get firstDayOfWeek(): number {
        return 1;
    }
    openOnChange(date:Date | undefined) {

        if(date) {

            this.setFormattedDate(this.date);

        } else {

            this.setFormattedDate('');

        }
    }
    private getFormattedDate(date: Date, separator: string = "-"): string {
        if (date) {
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
            const yyyy = date.getFullYear();
            return yyyy + separator + mm + separator + dd;
        } else {
            return '';
        }
    }
    constructor() {
        super();
    }

    mounted() {
        this.openOnChange(undefined);
    }

    //TODO: get calendar week - localisation
    private setFormattedDate(startDate: string) {
        if(startDate) {
            const date = moment(startDate);

        } else {

        }
    }
    private dayChanged() {
        this.dateMenu = false;
        const date = new Date(this.date);

        this.$emit("dayChanged", {start: date, end: date, title: this.formattedDate});
    }
    private get maxDate(): string {
        return this.getFormattedDate(new Date());
    }

    private clearDateValue() {

        this.dayChanged();
        //this.$emit("dayChanged",{date: this.getFormattedDate(new Date())});
        //this.$emit("input", this.weekRange[0]);
    }
}
</script>
<style>

</style>
